<template>
	<div class="stopExpertise">
		<el-dialog :visible="stopVisible">
			
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'stopExpertise',
		data() {
			return {
				stopVisible: false
			};
		},
		methods: {
			
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.photo {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
		background: @vue-bg-color-mask;
		display: flex;
		justify-content: center;
		align-items: center;

		.photo-content {
			width: 900px;
			height: 600px;
			background: @vue-bg-color;
			border-radius: @vue-border-radius-lg;
			position: relative;
			.close-video{
				width: 30px;
				height: 30px;
				position: absolute;
				right: 10px;
				top: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: @vue-font-size-base;
				cursor: pointer;
			}
			.video-area {
				width: 600px;
				height: 450px;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 2px solid #007AFF;
				box-sizing: border-box;
				margin: 0px  auto;
				margin-top: @vue-spacing-col-base*2;
				video,
				img {
					width: 100%;
					height: 100%;
				}
			}
			.photo-button {
				width: 100%;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: @vue-spacing-col-lg;
			
				.el-button {
					width: 300px;
					height: 40px;
					border-radius: 20px;
				}
			}
			
			canvas {
				width: 600px;
				height: 450px;
				opacity: 0;
			}
		}
	}
</style>
